import React, { useState } from 'react';
import toast from 'react-hot-toast';
import api from '../services/api';
import SEO from '../components/SEO';

const Kontaktai = () => {
  const [formData, setFormData] = useState({
    vardas: '',
    email: '',
    zinute: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      await api.post('/contacts', {
        name: formData.vardas,
        email: formData.email,
        message: formData.zinute
      });
      
      setIsSuccess(true);
      toast.success('Žinutė išsiųsta sėkmingai!', { duration: 5000 });
      setFormData({ vardas: '', email: '', zinute: '' });
    } catch (error) {
      toast.error('Nepavyko išsiųsti žinutės. Bandykite dar kartą.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div>
      <SEO 
        title="Kontaktai"
        description="Susisiekite su Sporto Krantu - adresas, telefonas, el. paštas. Atsakysime į visus jūsų klausimus ir padėsime suplanuoti poilsį."
        keywords="kontaktai, susisiekti, sporto krantas, adresas, telefonas, el. paštas"
        canonicalUrl="https://sportokrantas.lt/kontaktai"
      />
      {/* Contacts Section - Gold background */}
      <section className="py-16 lg:py-24 border-b-[3px] border-black" style={{ backgroundColor: '#D0AB64' }}>
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16">
            
            {/* Left side - Contact Info */}
            <div>
              <h1 className="text-black mb-10 tracking-wide leading-tight" style={{ fontSize: '29.5px', fontWeight: 700, WebkitTextStroke: '0.5px' }}>
                REKVIZITAI
              </h1>
              
              <div className="space-y-8">
                {/* Phone */}
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 rounded-full border-2 border-black flex items-center justify-center flex-shrink-0">
                    <svg className="w-5 h-5 text-black" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
                    </svg>
                  </div>
                  <div>
                    <h3 className="font-bold text-black text-lg">Telefonas</h3>
                    <p className="text-black">+370 634 00056</p>
                  </div>
                </div>

                {/* Email */}
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 rounded-full border-2 border-black flex items-center justify-center flex-shrink-0">
                    <svg className="w-5 h-5 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="font-bold text-black text-lg">El. paštas</h3>
                    <p className="text-black">info@sportokrantas.lt</p>
                  </div>
                </div>

                {/* Address */}
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 rounded-full border-2 border-black flex items-center justify-center flex-shrink-0">
                    <svg className="w-5 h-5 text-black" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
                    </svg>
                  </div>
                  <div>
                    <h3 className="font-bold text-black text-lg">Adresas</h3>
                    <p className="text-black">Vilniaus r. sav., Sužionių sen., Daukšių km., Liepų g. 63</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Right side - Contact Form */}
            <div className="p-8 lg:p-10" style={{ backgroundColor: '#111315' }}>
              <h2 className="text-center mb-8 tracking-wide" style={{ fontSize: '20px', fontWeight: 700, color: '#D0AB64' }}>
                PARAŠYKITE MUMS
              </h2>
              
              {isSuccess ? (
                <div className="text-center py-12">
                  <div className="w-20 h-20 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-6">
                    <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <h3 className="text-white text-xl font-semibold mb-3">Žinutė išsiųsta!</h3>
                  <p className="text-gray-300 mb-6">Dėkojame už Jūsų žinutę. Susisieksime su Jumis artimiausiu metu.</p>
                  <button
                    onClick={() => setIsSuccess(false)}
                    className="px-6 py-2 font-medium text-black rounded-full transition-colors hover:opacity-90"
                    style={{ backgroundColor: '#D0AB64' }}
                  >
                    Siųsti dar vieną žinutę
                  </button>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="space-y-5">
                  <div>
                    <input
                      type="text"
                      name="vardas"
                      placeholder="Vardas *"
                      value={formData.vardas}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 bg-white border-0 focus:outline-none focus:ring-2 focus:ring-[#D0AB64] text-sm"
                    />
                  </div>
                  <div>
                    <input
                      type="email"
                      name="email"
                      placeholder="El. paštas *"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 bg-white border-0 focus:outline-none focus:ring-2 focus:ring-[#D0AB64] text-sm"
                    />
                  </div>
                  <div>
                    <textarea
                      name="zinute"
                      placeholder="Žinutė *"
                      value={formData.zinute}
                      onChange={handleChange}
                      required
                      rows={8}
                      className="w-full px-4 py-3 bg-white border-0 focus:outline-none focus:ring-2 focus:ring-[#D0AB64] text-sm resize-none"
                    />
                  </div>
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="w-full py-3 font-medium text-black rounded-full transition-colors hover:opacity-90 disabled:opacity-50"
                    style={{ backgroundColor: '#D0AB64' }}
                  >
                    {isSubmitting ? 'Siunčiama...' : 'Siųsti'}
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Kontaktai;
